import { AfterViewInit, Component, inject, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MasterService } from "@frontend/app/serivces/master.service";
import { tap } from "rxjs";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { ExcelService } from "@frontend/app/serivces/excel.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-inquiry-data",
  imports: [CommonModule, SharedModule],
  templateUrl: "./inquiry-data.component.html",
  styleUrl: "./inquiry-data.component.scss",
})
export class InquiryDataComponent implements AfterViewInit {
  private masterService = inject(MasterService);
  private excelService = inject(ExcelService);
  private router = inject(Router);

  ngAfterViewInit(): void {
    this.paginator.page.pipe(tap(() => this.getInquiriesList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction))).subscribe();
    this.sort.sortChange.subscribe(() => {
      this.getInquiriesList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
    });
    this.getInquiriesList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
  }

  //#region variables
  inquiryList: any;
  displayedColumns: string[] = ["EnquiryID", "CreatedDate", "FirstName", "MobileNo", "Age", "ReferenceName", "CounsellorName"];
  dataSource = new MatTableDataSource();
  length = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  readonly SVG_ICONS = SVG_ICONS;
  //#endregion

  getInquiriesList(pageIndex: number, pageSize: number, sortColumn: string, sortDirection: string) {
    const sort = sortColumn ? `${sortColumn} ${sortDirection}` : "asc";
    this.masterService.getStudentInquiries(pageIndex, pageSize, sort.toString()).subscribe((res: any) => {
      this.inquiryList = res.data;
      this.length = res.total;
      this.dataSource.data = this.inquiryList;
    });
  }

  onCreateInquiry() {
    this.router.navigate(["inquiry-form"]);
  }

  generateExcel() {
    this.excelService.generateEvaluationSheet();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
}
